import type NativeArray from '@ember/array/-private/native-array';
import Controller from '@ember/controller';
import { service } from '@ember/service';
import type { Task } from 'ember-concurrency';
import type PluginInstall from 'garaje/models/plugin-install';
import type CurrentLocationService from 'garaje/services/current-location';
import { alias, or } from 'macro-decorators';
import { tracked } from 'tracked-built-ins';

import type SettingsNotificationsRoute from './route';
import type { SettingsNotificationsRouteModel } from './route';

export default class VisitorsSettingsNotificationsController extends Controller {
  queryParams = ['feature'];

  @service declare currentLocation: CurrentLocationService;

  declare model: SettingsNotificationsRouteModel['currentLocation'];

  declare employees: SettingsNotificationsRouteModel['employees'];
  declare fallbackContacts: SettingsNotificationsRouteModel['fallbackContacts'];
  declare vrSubscription: SettingsNotificationsRouteModel['vrSubscription'];
  declare fallbackContactsTask: Task<SettingsNotificationsRouteModel['fallbackContacts'], []>;
  declare reloadFallbackContacts: SettingsNotificationsRoute['reloadFallbackContacts'];
  declare installedPlugins: NativeArray<PluginInstall>;
  declare connectedTenants: SettingsNotificationsRouteModel['connectedTenants'];
  declare connectLocationConfiguration: SettingsNotificationsRouteModel['connectLocationConfiguration'];
  declare config: SettingsNotificationsRouteModel['config'];

  @alias('currentLocation.location.hostNotificationsEnabled')
  hasNotificationEnabled!: CurrentLocationService['location']['hostNotificationsEnabled'];
  @or('fallbackContactsHasChanges', 'model.hasDirtyAttributes') hasDirtyChanges!: boolean;

  @tracked showBlankState?: boolean;
  @tracked feature = '';
  @tracked fallbackContactsHasChanges = false;

  rollbackDirtyChanges = (): void => {
    if (<boolean>(<unknown>this.model.hasDirtyAttributes)) {
      this.model.rollbackAttributes();
    }
    if (this.fallbackContactsHasChanges) {
      void this.rollbackFallbackContacts();
    }
  };

  rollbackFallbackContacts = async (): Promise<void> => {
    // Reset to clean state so confirm dialog is not sticky
    this.fallbackContactsHasChanges = false;
    this.feature = '';
    await this.reloadFallbackContacts(); // set by route
  };
}
